// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"CY","sticky_header_title":"EY","stycky_header_title_mob":"FY","root_scroller":"GY","scroller":"HY","indicator":"IY","scrollButtons":"JY","selected":"KY","root_tab_scrollable":"LY","root_scroller_mob":"MY","scroller_mob":"NY","indicator_mob":"OY","selected_mob":"PY","root_tab_mob":"QY","root_tab_mob_scrollable":"RY","sticky_header_title_mob":"SY"};
    if(module.hot) {
      // 1714442371356
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  